import * as yup from 'yup';
import { messages } from 'app/config/constants';

export const filedLawsuitValidationSchema = yup.object().shape({
  lawsuitFiled: yup.boolean().required(messages.MANDATORY_FIELD),
  lawsuitSolutionSecondDegree: yup.array().when('lawsuitFiled', (val, schema) => {
    return val[0] ? yup.array().min(1, messages.MANDATORY_FIELD).required(messages.MANDATORY_FIELD) : yup.array().notRequired();
  }),
});
